<template>
  <div class="background"  :style="background">
    <div class="homeWelcome">
        欢迎使用学生视力分析平台
    </div>
  </div>
  
</template>

<script>
export default {
  name: "index",
  data () {
    return {
      // 顶部导航背景图片配置
      background: {
      	// 背景图片地址 dist\img\back.png
        backgroundImage: 'url(' + require('@/assets/background.jpg') + ')',
        // 背景图片是否重复
        backgroundRepeat: 'no-repeat',
        // 背景图片大小
        backgroundSize: 'cover',
        // 背景颜色
        // backgroundColor: '#000',
        // 背景图片位置
        backgroundPosition: 'center top'
      }
    }
  }
}
</script>

<style scoped>
.homeWelcome {
  text-align: center;
  font-size: 36px;
  font-family: 华文行楷;
  color: #409eff;
  padding-top: 30px;

}
.background{
  padding-top: 0px;
  width:100%;
  height:100%;
}
</style>